import script from "./TileRank.vue?vue&type=script&setup=true&lang=ts"
export * from "./TileRank.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__